module.exports = __webpack_public_path__ + "img/birthday parties.62878413.jpg";